module.exports = __webpack_public_path__ + "img/16.efaffb81.png";